// 本地长存数据
// 获取车辆信息，
// 在更换关注店铺，
// 登录商城，
// 登录我的账号 
// 修改新增车辆 的时候进行刷新
import axios from 'axios'
axios.defaults.headers['Accept'] = 'application/json'
axios.defaults.headers['Content-Type'] = 'application/json'
import { CarApi } from '@/api/car'

export function getCars () {
    const car = localStorage.getItem('car')
    if (car != null) {
        return JSON.parse(car)
    } else {
        return null
    }
}
export function refreshCars() {
    axios.get(CarApi).then((ret) => {
        if (ret.flag) {
            // id,carcategory_id,carcategory_name,
            // carbody_no,area_name,areashort_id,
            // body_color,code,engine_no,is_default
            if (ret.details.length > 0) {
                const item = ret.details[0]
                localStorage.setItem('car', JSON.stringify({
                    'curCar': item,
                    'cars': ret.details 
                }))
            }
        }
    })
}
export function setCurrentCar(item) {
    const car = getCars()
    if (car != null) {
        localStorage.setItem('car', JSON.stringify({
            'curCar': item,
            'cars': car.cars 
        }))
    } else {
        return null
    }
}

// 当前微信的用户信息存入本地
// 来自微信返回的信息
// {
//     city: '',
//     country:'',
//     headimgurl: '...', 有值
//     language: '',
//     nickname: 'heyong', 有值
//     openid: '....',有值
//     privilege: '',
//     province: '',
//     sex: 0,
//     unionid: '.....'有值
// }
export function setCurrentWechatUsr(item) {
    if (item) {
        localStorage.setItem('currentWechatUsr', JSON.stringify(item))
    }
}

// 获取微信的当前用户信息
export function getCurrentWechatUsr() {
    let obj = localStorage.getItem('currentWechatUsr')
    if (obj != null) {
        return JSON.parse(obj)
    } else {
        return null
    }
}